export default "__VITE_ASSET__NGu9IBim__"